import { Component, OnDestroy, inject } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { SettingsService } from '../../../core/services/settings.service';
import { Settings } from '../../../core/Interfaces/settings';
import { FormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';

@Component({
  selector: 'app-settings-autofocus',
  imports: [MatCard, MatCheckbox, FormsModule, MatLabel],
  templateUrl: './autofocus.component.html',
  styleUrl: './autofocus.component.scss',
})
export class AutofocusComponent implements OnDestroy {
  private settingsService = inject(SettingsService);

  sub;
  settings: Settings | undefined;

  constructor() {
    this.sub = this.settingsService.getSubject().subscribe((value) => {
      this.settings = value;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  change() {
    if (!this.settings) {
      return;
    }
    this.settingsService.updateAutofocus(!this.settings.autofocus);
  }
}
